<template>
  <div class="slm-history-map">
    <map-component/>
    <div class="slm-history-map__heading-container">
      <h2 class="slm-history-map__heading" v-if="heading">{{ heading }}</h2>
    </div>
    <filters-component/>
    <result-wrapper-component/>
  </div>
</template>

<script>
import filtersComponent from './components/filters.vue';
import mapComponent from './components/map.vue';
import resultWrapperComponent from './components/result-wrapper.vue';

export default {
  name: 'App-template',
  computed: {
    heading() {
      return this.$store.state.heading;
    }
  },
  components: {
    filtersComponent,
    mapComponent,
    resultWrapperComponent
  }
}
</script>
